// Smarticks: appointment reminders. Plan: docs/smarticks/smarty-reminders-plan.md.
// Administrator-only -- enabling a process starts sending PAID WhatsApp messages to patients.
import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from 'dashboard/components/widgets/smarticks/RemindersIndex.vue';

const meta = { permissions: ['administrator'] };

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/reminders'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'reminders_wrapper',
          meta,
          redirect: to => ({ name: 'reminders_list', params: to.params }),
        },
        { path: 'list', name: 'reminders_list', meta, component: Index },
      ],
    },
  ],
};
